import { isServer } from 'src/libs/helper'
import { CompanyRepository } from 'src/repositories'
import { CompanyEntity } from 'src/types'

export const useCompanyStorage = () => {
  const saveCompanyToLocalStorage = (company: CompanyEntity): void => {
    if (isServer) {
      throw new Error("don't call in SSR for save company to local storage.")
    }

    CompanyRepository.saveCompanyIdToLocalStorage(company.id)
    CompanyRepository.saveCompanyNameToLocalStorage(company.name)
  }

  const loadCompanyFromLocalStorage = (): { companyId: number; companyName: string } | null => {
    if (isServer) {
      throw new Error("don't call in SSR for load company to local storage.")
    }

    const companyId = CompanyRepository.loadCompanyIdToLocalStorage()
    const companyName = CompanyRepository.loadCompanyNameToLocalStorage()

    return companyId && companyName ? { companyId, companyName } : null
  }

  const removeCompanyFromLocalStorage = (): void => {
    if (isServer) {
      throw new Error("don't call in SSR for remove company to local storage.")
    }

    CompanyRepository.removeCompanyIdFromLocalStorage()
    CompanyRepository.removeCompanyNameFromLocalStorage()
  }

  return {
    saveCompanyToLocalStorage,
    loadCompanyFromLocalStorage,
    removeCompanyFromLocalStorage,
  }
}
